import React, { Component } from "react";
import {
  ChangeParams,
  IsCheckAllParams,
  CheckAllParams
} from "./common.typing";
import { idTrans } from "./utils";

// HOC 注入的 props
export interface InjectedHocProps {
  onChangeHoc: (params: ChangeParams) => void;
  onCheckAllHoc: (params: CheckAllParams) => void;
  isCheckAllHoc: (params: IsCheckAllParams) => boolean;
}

function listChangeHoc(WrappedComponent: any) {
  return class extends Component<any> {
    onChangeHoc = ({
      value,
      checked,
      list,
      currentList,
      setCurrentList,
    }: ChangeParams) => {
      const newCurList = [...currentList];
      const ids = newCurList.map((v) => v.id);
      const item = list.find((v) => v.id == value); // 使用==而不是===进行更灵活的比较
      const valueExists = ids.some(id => id == value); // 使用==进行比较

      if (valueExists && !checked) {
        setCurrentList(currentList.filter((v) => v.id != value));
      }
      if (!valueExists && checked) {
        item && setCurrentList([...currentList, item]);
      }
    };

    onCheckAllHoc = ({
      value,
      checked,
      list,
      disabledids = [],
      currentList,
      setCurrentList,
      requiredList,
    }: CheckAllParams) => {
      let newCurList = [...currentList];
      let currids = newCurList.map((v) => v.id);
      let all = [...list];
      let allids = all.map((v) => v.id);

      const requiredIds = requiredList
        ? requiredList.map((v) => idTrans(v.id.toString()))
        : [];

      if (checked) {
        all.forEach((user) => {
          const id = idTrans(user.id.toString());
          if (
            user.id &&
            !currids.includes(user.id) &&
            !disabledids.includes(id) &&
            !requiredIds?.includes(id)
          ) {
            newCurList.push(user);
          }
        });
      } else {
        newCurList = newCurList.filter((v) => {
          const id = idTrans(v.id.toString());
          return (
            !allids.includes(v.id) ||
            disabledids.includes(id) ||
            requiredIds.includes(id)
          );
        });
      }
      setCurrentList([...newCurList]);
    };

    isCheckAllHoc = ({
      list,
      currentList,
      disabledids = [],
    }: IsCheckAllParams) => {
      const newCurList = [...currentList];
      const currids = newCurList.map((v) => v.id);
      const all = [...list];

      for (const i of all) {
        const id = idTrans(i.id.toString());
        if (!currids.includes(i.id) && !disabledids.includes(id)) {
          return false;
        }
      }
      if (!all.length) return false;
      return true;
    };

    render() {
      const newProps = {
        onChangeHoc: this.onChangeHoc,
        onCheckAllHoc: this.onCheckAllHoc,
        isCheckAllHoc: this.isCheckAllHoc,
      };
      return <WrappedComponent {...this.props} {...newProps} />;
    }
  };
}

export default listChangeHoc;
